export enum Role {
  Admin = 'Admin',
  Association = 'Association',
  Funder = 'Funder'
}
